export default {
    title: 'Kostenstelle erstellen',
    name: 'Bezeichnung',
    buyerReference: 'Kostenstelle',
    createCostCenter: 'Kostenstelle erstellen',
    createCostCenterSuccess: 'Die Kostenstelle wurde erfolgreich erstellt.',
    createCostCenterError: 'Die Kostenstelle konnte nicht erstellt werden.'
}